module.exports = __webpack_public_path__ + "img/shakeys_sign.ed90d2fa.jpg";